module.exports = __webpack_public_path__ + "static/media/violao.72a2100a.svg";